import { useState, useEffect } from "react";
import { getDimensions, getVehicles, getVehicleTypes } from "../services/vehicles";

let cachedDimensions = null, cachedVehicleTypes = null, cachedVehicles = {}; // global in-memory cache

export const useDimensions = ({ reload = false } = {}) => {

  const [dimensions, setDimensions] = useState(cachedDimensions || []);
  const [loading, setLoading] = useState(false);

  const fetchDimensions = async () => {
    setLoading(true);
    try {
      const [err, data] = await getDimensions();
      if (!err) {
        cachedDimensions = data.results || [];
        setDimensions(cachedDimensions);
      }
    } catch (e) {
      console.error("Error fetching dimensions:", e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!cachedDimensions || reload) {
      fetchDimensions();
    } else {
      setDimensions(cachedDimensions);
    }
  }, [reload]); // refetch if reload or params change

  return { dimensions, loading, refresh: fetchDimensions };
};

export const useVehicleTypes = ({ reload = false } = {}) => {

  const [vehicleTypes, setVehicleTypes] = useState(cachedVehicleTypes || []);
  const [loading, setLoading] = useState(false);

  const fetchVehicleTypes = async () => {
    setLoading(true);
    try {
      const [err, data] = await getVehicleTypes();
      if (!err) {
        cachedVehicleTypes = data || [];
        setVehicleTypes(cachedVehicleTypes);
      }
    } catch (e) {
      console.error("Error fetching vehicle types:", e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!cachedVehicleTypes || reload) {
      fetchVehicleTypes();
    } else {
      setVehicleTypes(cachedVehicleTypes);
    }
  }, [reload]); // refetch if reload or params change

  return { vehicleTypes, loading, refresh: fetchVehicleTypes };
};

export const useVehicles = ({ reload = false, params = {} } = {}) => {

  const key = JSON.stringify(params); // unique cache key for these params
  const [vehicles, setVehicles] = useState(cachedVehicles[key] || []);
  const [loading, setLoading] = useState(false);

  const fetchVehicles = async () => {
    setLoading(true);
    try {
      const [err, data] = await getVehicles(params);
      if (!err) {
        cachedVehicles[key] = data || [];
        setVehicles(cachedVehicles[key]);
      }
    } catch (e) {
      console.error("Error fetching vehicles:", e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (!cachedVehicles[key] || (cachedVehicles[key]?.length <= 0) || reload) {
      fetchVehicles();
    } else {
      setVehicles(cachedVehicles[key]);
    }
  }, [reload]); // refetch if reload or params change

  return { vehicles, loading, refresh: fetchVehicles };
};
